import DataDefinitionsClient from './data-definitions-client';
import {EventDefinition} from './data-definitions-types';
import {EventParams} from 'common/util/definitions-types';

const SESSION_EVENT_DEFINITIONS: EventDefinition[] = [
  {
    name: `$session_start`,
    displayName: `Session Start`,
    description: `Mixpanel's virtual event triggered at the start of each user's session. Customize session timeout length, exclude events from sessions, or define event based sessions in project settings. [More about sessions](https://help.mixpanel.com/hc/en-us/articles/115004695223-Track-Sessions)`,
    verified: true,
    id: null,
    collectEverythingEventId: null,
    customEventId: null,
    tags: [],
    platforms: [],
  },
  {
    name: `$session_end`,
    displayName: `Session End`,
    description: `Mixpanel's virtual event triggered at the end of each user's session. Customize session timeout length, exclude events from sessions, or define event based sessions in project settings. [More about sessions](https://help.mixpanel.com/hc/en-us/articles/115004695223-Track-Sessions)`,
    verified: true,
    id: null,
    collectEverythingEventId: null,
    customEventId: null,
    tags: [],
    platforms: [],
  },
];

class EventDefinitionsClient extends DataDefinitionsClient {
  buildEndpoint({projectId, workspaceId}) {
    return `${super.buildEndpoint({projectId, workspaceId})}/events`;
  }

  buildQueryParams({id, name, customEventId, collectEverythingEventId}: EventParams = {}) {
    return {id, name, customEventId, collectEverythingEventId};
  }

  processResponse(response, params) {
    const specifierParams = [`id`, `name`, `customEventId`, `collectEverythingEventId`];
    const isSpecificQuery = Object.keys(params).some((k) => specifierParams.includes(k));
    if (isSpecificQuery) {
      return response.results;
    } else {
      return [...response.results, ...SESSION_EVENT_DEFINITIONS];
    }
  }
}

export default new EventDefinitionsClient();
